<template>
    <div v-if="feedback">
        <div class="mb-2">
            <div class="text-center">
                <blockquote class="h3  mb-4">
                    {{ feedback.description }}
                </blockquote>
                <span class="client-name">{{ feedback.name }}, {{ feedback.title }}</span>
            </div>
        </div>
        <div class="d-flex justify-content-center position-relative height-100">
            <div class="avatar-slider-comment" :style="{backgroundImage: 'url(' + feedback.avatar + ')'}"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            feedback: {
                default: null,
            }
        }
    }
</script>
